// Our product database.
const sampleProducts = [
  {
    id: 1,
    name: "Кондиционер Dove Advanced Hair Series для волос прогрессивное восстановление 250мл",
    category: "Clothing and Shoes",
    price: 55,
    description:
      "The Nike Air Presto Women's Shoe delivers the same unrivaled fit and comfort that marked the 2000 debut of the original.",
    popular: true,
    imageUrls: [
      "https://mdm.esphere.ru/ords/mdm/api/tmpblob?uniq=3007186580&rnd=L4P0OBBI3BLRF4XPP3FJ",
      "https://media.hypedc.com/media/catalog/product/cache/1/image/750x/9df78eab33525d08d6e5fb8d27136e95/_/o/_o8a4329_2.jpg"
    ]
  }
];

const brands = [
  {
    rn: 1,
    id: "3711750605",
    comments: "MARS Wrigley",
    value_ru: "Five",
    value_en: "Five",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-05/5-Gum_3.png?itok=mAwCs_8y"
  },
  {
    rn: 2,
    id: "3711750688",
    comments: "MARS Wrigley",
    value_ru: "Be-Kind",
    value_en: "Be-Kind",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-05/Kind_0.png?itok=qFYx4SKA"
  },
  {
    rn: 3,
    id: "3711742067",
    comments: "MARS Wrigley",
    value_ru: "Bounty",
    value_en: "Bounty",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-05/Bounty_16.png?itok=5iFQaUCg"
  },
  {
    rn: 4,
    id: "3713138521",
    comments: "MARS PetFood",
    value_ru: "CESAR",
    value_en: "CESAR",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2023-10/Cesar%20copy.png?h=df145728&itok=GJP4TZ0A"
  },
  {
    rn: 5,
    id: "3713138640",
    comments: "MARS PetFood",
    value_ru: "CHAPPI",
    value_en: "CHAPPI",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2023-10/Chappie_logo.png?h=df145728&itok=5HJUluUP"
  },
  {
    rn: 6,
    id: "3713138402",
    comments: "MARS PetFood",
    value_ru: "Catsan",
    value_en: "Catsan",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2023-10/catsan_logo.png?h=df145728&itok=ljRc8ElX"
  },
  {
    rn: 7,
    id: "3711742089",
    comments: "MARS Wrigley",
    value_ru: "Celebrations",
    value_en: "Celebrations",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-05/Celebrations_8.png?itok=qQRqAdXO"
  },
  {
    rn: 8,
    id: "3713134040",
    comments: "MARS Food",
    value_ru: "DOLMIO",
    value_en: "DOLMIO",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/2024-07/Dolmio%20Carbonara%20Pasta%20Sauce%20Pouch%20150g%20%281%29.jpg"
  },
  {
    rn: 9,
    id: "3711750771",
    comments: "MARS Wrigley",
    value_ru: "Doublemint",
    value_en: "Doublemint",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-05/Doublemint-White_2.png?itok=mwDC9Twa"
  },
  {
    rn: 10,
    id: "3711742079",
    comments: "MARS Wrigley",
    value_ru: "Dove",
    value_en: "Dove",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2025-05/Dove.png?itok=-eYVIaw5"
  },
  {
    rn: 11,
    id: "3713138759",
    comments: "MARS PetFood",
    value_ru: "DREAMIES",
    value_en: "DREAMIES",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2023-10/Dreamies%20logo.png?h=df145728&itok=J--WfpNy"
  },
  {
    rn: 12,
    id: "3711750854",
    comments: "MARS Wrigley",
    value_ru: "Eclipse",
    value_en: "Eclipse",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-05/Eclipse.png?itok=0QTDcQ6s"
  },
  {
    rn: 13,
    id: "3713138878",
    comments: "MARS PetFood",
    value_ru: "ELIOTT",
    value_en: "ELIOTT",
    image: null
  },
  {
    rn: 14,
    id: "3711750937",
    comments: "MARS Wrigley",
    value_ru: "Juicy Fruit",
    value_en: "Juicy Fruit",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-05/Juicy-Fruit_7.png?itok=uM__Kqms"
  },
  {
    rn: 15,
    id: "3713138997",
    comments: "MARS PetFood",
    value_ru: "KITEKAT",
    value_en: "KITEKAT",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2023-11/Kitekat_logo.png?h=df145728&itok=p1SZ_pM3"
  },
  {
    rn: 16,
    id: "3711742075",
    comments: "MARS Wrigley",
    value_ru: "M&M's",
    value_en: "M&M's",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-05/M%26Ms_14.png?itok=d7ujcCwP"
  },
  {
    rn: 18,
    id: "3711742077",
    comments: "MARS Wrigley",
    value_ru: "Maltesers",
    value_en: "Maltesers",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-05/Maltesers-White_16.png?itok=GvSwMem9"
  },
  {
    rn: 19,
    id: "3711742069",
    comments: "MARS Wrigley",
    value_ru: "Mars",
    value_en: "Mars",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-06/Mars_6.png?itok=Qp3n_hCP"
  },
  {
    rn: 20,
    id: "3711742073",
    comments: "MARS Wrigley",
    value_ru: "Milky Way",
    value_en: "Milky Way",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-06/Mars%20Brand%20Logos%20Web%20Confectionery%20Milky%20Way%20UK%20Large_0_1_13.png?itok=HqBoF3BF"
  },
  {
    rn: 21,
    id: "3713134159",
    comments: "MARS Food",
    value_ru: "MasterFoods",
    value_en: "MasterFoods",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/cropped_freeform/public/2025-05/MasterFoods_0.png?itok=xEkOiF7-"
  },
  {
    rn: 23,
    id: "3711742087",
    comments: "MARS Wrigley",
    value_ru: "Mixed Minis",
    value_en: "Mixed Minis",
    image: null
  },
  {
    rn: 24,
    id: "3713139116",
    comments: "MARS PetFood",
    value_ru: "NATURE'S TABLE",
    value_en: "NATURE'S TABLE",
    image: null
  },
  {
    rn: 25,
    id: "3711751020",
    comments: "MARS Wrigley",
    value_ru: "Orbit",
    value_en: "Orbit",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2024-10/webimage-logos_mars_2019_pagina_01-jpg_0.png?itok=g9i2IEBj"
  },
  {
    rn: 26,
    id: "3713139235",
    comments: "MARS PetFood",
    value_ru: "PEDIGREE",
    value_en: "PEDIGREE",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2025-09/sqimg_48157731_0.png?itok=N67q-rHZ"
  },
  {
    rn: 27,
    id: "3713139354",
    comments: "MARS PetFood",
    value_ru: "PERFECT FIT",
    value_en: "PERFECT FIT",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2023-11/logo_perfect_fit_cat.png?h=df145728&itok=zltIAaHC"
  },
  {
    rn: 28,
    id: "3711751103",
    comments: "MARS Wrigley",
    value_ru: "Rondo",
    value_en: "Rondo",
    image: null
  },
  {
    rn: 29,
    id: "3713139473",
    comments: "MARS PetFood",
    value_ru: "SHEBA",
    value_en: "SHEBA",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2025-09/New%20Sheba%20Logo%202025.png?itok=14YQjCM4"
  },
  {
    rn: 30,
    id: "3711751186",
    comments: "MARS Wrigley",
    value_ru: "Skittles",
    value_en: "Skittles",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-06/Skittles_33.png?itok=8v05y7K6"
  },
  {
    rn: 31,
    id: "3711742071",
    comments: "MARS Wrigley",
    value_ru: "Snickers",
    value_en: "Snickers",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/cropped_crop_3_2/public/2024-11/SNICKERS_Crisp_Eis_Single.PNG?itok=5lI3gKHF"
  },
  {
    rn: 32,
    id: "3711751269",
    comments: "MARS Wrigley",
    value_ru: "Spearmint",
    value_en: "Spearmint",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/content_cards_340x340/public/2025-06/Spearmint_3.png?itok=145EubQR"
  },
  {
    rn: 34,
    id: "3711742065",
    comments: "MARS Wrigley",
    value_ru: "Twix",
    value_en: "Twix",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2025-06/Twix-White_20.png?itok=ppbKLXN3"
  },
  {
    rn: 35,
    id: "3713134278",
    comments: "MARS Food",
    value_ru: "Uncle Ben’s",
    value_en: "Uncle Ben’s",
  },
  {
    rn: 36,
    id: "3713139592",
    comments: "MARS PetFood",
    value_ru: "WHISKAS",
    value_en: "WHISKAS",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2024-01/Whiskas%20logo%20new.png?h=3bbeb2bd&itok=UTh3NKMK"
  },
  {
    rn: 37,
    id: "3711751352",
    comments: "MARS Wrigley",
    value_ru: "Коркунов",
    value_en: "Коркунов",
    image: null
  },
  {
    rn: 38,
    id: "3852962792",
    comments: "MARS PetFood",
    value_ru: "CRAVE",
    value_en: "CRAVE",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2023-10/logo_crave.png?h=df145728&itok=tpRZLQX4"
  },
  {
    rn: 39,
    id: "3857287834",
    comments: "MARS PetFood",
    value_ru: "NUTRO",
    value_en: "NUTRO",
    image: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/image_grid_1_1_282x282/public/2025-07/Nutro.png?itok=-jDOsP0j"
  },
  {
    rn: 40,
    id: "3802460853",
    comments: "MARS Food",
    value_ru: "Ben's Original",
    value_en: "Ben's Original",
  }
];

const dataForTheMenu = [
  {
    name: "Petcare",
    desc: "Mars Petcare объединяет более 85 тысяч сотрудников, которые заботятся о домашних животных во всем мире. Мы создаем качественное питание, предоставляем ветеринарную поддержку и другие сервисы. Вместе мы делаем мир для домашних животных лучше.",
    id: 1,
    img: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/two_column_basic_row_w1200/public/2025-07/OurBrands-Petcare-3_2.png?itok=r1TBrdyB",
    children: brands.filter(e => e.comments === "MARS PetFood").map((x, i) => ({
      name: x.value_ru,
      nameEn: x.value_en,
      id: i,
      url: "/products?category=" + x.id,
      icon: x.icon,
      image: x.image,
      cross_id: x.id
    }))
  },
  {
    name: "Wrigley",
    id: 2,
    img: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/two_column_basic_row_w1200/public/2025-07/OurBrands-Snacking-3_2.png?itok=UI5MpZ9k",
    desc: "Лучшие моменты дарят миру улыбки. Уже больше 100 лет мы создаем лучшие моменты благодаря нашим лакомствам и перекусам: M&M’S®, SNICKERS®, ORBIT® и TWIX®. Почему мы это делаем каждый день? Мы хотим делать наши продукты еще лучше, делиться ими с окружающими и дарить миру еще больше улыбок!",
    children: brands.filter(e => e.comments === "MARS Wrigley").map((x, i) => ({
      name: x.value_ru,
      nameEn: x.value_en,
      id: i,
      url: "/products?category=" + x.id,
      icon: x.icon,
      image: x.image,
      cross_id: x.id
    }))
  },
  {
    name: "Food",
    id: 3,
    img: "https://www.mars.com/sites/g/files/dfsbuz106/files/styles/two_column_basic_row_w1200/public/2025-07/OurBrands-Food%26Nutriton-3_2.png?itok=4b4izUa0",
    desc: "Еда — это не просто калории и питательные вещества — это нечто большее. Наша цель — улучшать питание сегодня, чтобы создавать лучший мир завтра. Наши марки UNCLE BEN'S®, DOLMIO® и SEEDS OF CHANGE™ могут и должны положительно влиять на людей и планету. Сегодня мы работаем над тем, чтобы к 2021 году миллиард здоровых блюд стоял на обеденных по всему миру.",
    children: brands.filter(e => e.comments === "MARS Food").map((x, i) => ({
      name: x.value_ru,
      nameEn: x.value_en,
      id: i,
      url: "/products?category=" + x.id,
      icon: x.icon,
      image: x.image,
      cross_id: x.id
    }))
  }
];

export { sampleProducts, dataForTheMenu, brands };
